<div class="tp-input d-flex flex-row border-0" [ngbPopover]="timePopover" placement="bottom-left" triggers="manual" [autoClose]="'outside'" #p="ngbPopover" (click)="!disabled ? p.open() : null">
    <input class="form-control tp-time" 
      [(ngModel)]="modelDisplay" 
      [placeholder]="placeholderDate | date: timeFormat"
      [readonly]="!disabled" 
      [disabled]="disabled" 
      [style.cursor]="disabled ? 'default' : 'pointer'"/>
    <i class="tp-icon d-flex justify-content-center align-items-center rounded-right" [style.cursor]="disabled ? 'default' : 'pointer'" (click)="focusInput()"><svg class="icon-16 fill-valyrianSteel"><use href="../App_Themes/clearview-default/icons/utility/time.svg#time"></use></svg></i>
</div>

<ng-template #timePopover>
    <ngb-timepicker [(ngModel)]="ngbModel" 
      [disabled]="disabled"
      (ngModelChange)="onTimePickerChanged()" 
      [hourStep]="1" 
      [minuteStep]="15" 
      [meridian]="!use24Hour">
    </ngb-timepicker>
</ng-template>